export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20product%20flatlay%20featuring%20stylish%20sneakers%20a%20leather%20bag%20and%20accessories%20arranged%20on%20cream%20textured%20linen%20fabric%2C%20soft%20diffused%20window%20light%20from%20left%2C%20editorial%20catalog%20photography%2C%20beige%20and%20warm%20grey%20palette%2C%20clean%20elegant%20composition%2C%20no%20text%2C%20no%20branding&width=1600&height=900&seq=hero-main-v2&orientation=landscape"
          alt="AllChinaBuy Spreadsheet product showcase"
          title="Best AllChinaBuy Spreadsheet 2026"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-tight">
            Best AllChinaBuy Spreadsheet 2026
          </h1>
          <p className="mt-5 md:mt-6 text-base md:text-lg text-background-50/85 max-w-xl mx-auto leading-relaxed">
            Find trusted sellers, verified products, and updated buying guides in the most complete AllChinaBuy Spreadsheet. Discover sneakers, clothing, bags, and accessories from reliable sellers with transparent ratings.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-base font-semibold rounded-md hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              allchinabuy sheet
              <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/90 text-foreground-900 text-base font-semibold rounded-md hover:bg-background-50 transition-all cursor-pointer whitespace-nowrap"
            >
              buy it now
              <i className="ri-shopping-cart-line w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href="#categories"
              className="inline-flex items-center gap-2 px-8 py-3.5 border border-background-50/40 text-background-50 text-base font-semibold rounded-md hover:bg-background-50/10 transition-all cursor-pointer whitespace-nowrap"
            >
              Browse Categories
              <i className="ri-arrow-down-line w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}